import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import MonthTable from './MonthTable';
import dayjs from '../dayjs';
var emptyFn = function () { };
injectStyle("components/DatePicker/rc-calendar/style/common/MonthPanel.css", "[data-dui-0-122-5~=\"dui-calendar-month-panel\"]{position:absolute;z-index:10;top:0;right:0;bottom:0;left:0;background:#fff}[data-dui-0-122-5~=\"dui-calendar-month-panel\"]>div{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}[data-dui-0-122-5~=\"dui-calendar-month-panel-hidden\"]{display:none}[data-dui-0-122-5~=\"dui-calendar-month-panel-header\"]{position:relative;height:66px;padding:0 10px;font-size:16px;line-height:66px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-month-panel-header\"]>a{display:inline-block;cursor:pointer;font-weight:600;text-align:center}[data-dui-0-122-5~=\"dui-calendar-month-panel-header\"]>a:hover{color:#175ceb}[data-dui-0-122-5~=\"dui-calendar-month-panel-next-year-btn\"],[data-dui-0-122-5~=\"dui-calendar-month-panel-prev-year-btn\"]{position:absolute;top:0;bottom:0;margin:auto 0}[data-dui-0-122-5~=\"dui-calendar-month-panel-next-year-btn\"]:hover,[data-dui-0-122-5~=\"dui-calendar-month-panel-prev-year-btn\"]:hover{background-color:#e9ebed}[data-dui-0-122-5~=\"dui-calendar-month-panel-prev-year-btn\"]{left:45px;width:16px;height:16px;background:url(../img/arrow_double@2x.png) no-repeat 50%/contain;-webkit-transform:rotate(180deg);transform:rotate(180deg)}[data-dui-0-122-5~=\"dui-calendar-month-panel\"] [data-dui-0-122-5~=\"dui-calendar-month-panel-year-select\"]{width:180px}[data-dui-0-122-5~=\"dui-calendar-month-panel-year-select-arrow\"]{display:none}[data-dui-0-122-5~=\"dui-calendar-month-panel-next-year-btn\"]{right:45px;width:16px;height:16px;background:url(../img/arrow_double@2x.png) no-repeat 50%/contain}[data-dui-0-122-5~=\"dui-calendar-month-panel-body\"]{position:absolute;top:34px;bottom:0;padding:9px 10px 10px}[data-dui-0-122-5~=\"dui-calendar-month-panel-footer\"]{border-top:1px solid #c2c2c2;line-height:38px}[data-dui-0-122-5~=\"dui-calendar-month-panel-table\"]{width:100%;height:100%;border-collapse:separate;table-layout:fixed}[data-dui-0-122-5~=\"dui-calendar-month-panel-cell\"]{text-align:center}[data-dui-0-122-5~=\"dui-calendar-month-panel-cell\"] [data-dui-0-122-5~=\"dui-calendar-month-panel-month\"]{display:block;width:46px;height:36px;padding:0;margin:0 auto;background:transparent;border-radius:4px;color:var(--text-ultrastrong,rgba(0,0,0,.88));cursor:pointer;line-height:36px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-month-panel-cell\"] [data-dui-0-122-5~=\"dui-calendar-month-panel-month\"]:hover{background:rgba(0,0,0,.04)}[data-dui-0-122-5~=\"dui-calendar-month-panel-cell-disabled\"] [data-dui-0-122-5~=\"dui-calendar-month-panel-month\"]{color:var(--text-weak,rgba(0,0,0,.24));cursor:not-allowed}[data-dui-0-122-5~=\"dui-calendar-month-panel-cell-disabled\"] [data-dui-0-122-5~=\"dui-calendar-month-panel-month\"]:hover{background:#fff}[data-dui-0-122-5~=\"dui-calendar-month-panel-selected-cell\"] [data-dui-0-122-5~=\"dui-calendar-month-panel-month\"],[data-dui-0-122-5~=\"dui-calendar-month-panel-selected-cell\"] [data-dui-0-122-5~=\"dui-calendar-month-panel-month\"]:hover{background:#1e6fff;color:#fff}[data-dui-0-122-5~=\"dui-calendar-month-header-wrap\"]{position:relative;height:308px}");
var MonthPanel = (function (_super) {
    __extends(MonthPanel, _super);
    function MonthPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prefixCls = _this.props.rootPrefixCls + "-month-panel";
        _this.state = {
            value: _this.props.value || _this.props.defaultValue,
        };
        _this.nextYear = function () {
            _this.props.changeYear(1);
        };
        _this.previousYear = function () {
            _this.props.changeYear(-1);
        };
        _this.setAndSelectValue = function (value) {
            var onSelect = _this.props.onSelect;
            _this.setValue(value);
            onSelect(value);
        };
        return _this;
    }
    MonthPanel.getDerivedStateFromProps = function (props) {
        return props.value ? {
            value: props.value,
        } : null;
    };
    MonthPanel.prototype.setValue = function (value) {
        if (this.props.value) {
            return;
        }
        this.setState({
            value: value,
        });
    };
    MonthPanel.prototype.renderHeader = function () {
        var prefixCls = this.prefixCls;
        var _a = this.props, locale = _a.locale, onYearPanelShow = _a.onYearPanelShow;
        var value = this.state.value;
        var year = value.year();
        return (h("div", { className: prefixCls + "-header" },
            h("span", { className: prefixCls + "-prev-year-btn", role: "button", tabIndex: "0", title: locale.previousYear, onClick: this.previousYear, onKeyDown: emptyFn }),
            h("span", { className: prefixCls + "-year-select", role: "button", tabIndex: "0", title: locale.yearSelect, onClick: onYearPanelShow, onKeyDown: emptyFn },
                h("span", { className: prefixCls + "-year-select-content" }, year),
                h("span", { className: prefixCls + "-year-select-arrow" }, "x")),
            h("span", { className: prefixCls + "-next-year-btn", role: "button", tabIndex: "0", title: locale.nextYear, onClick: this.nextYear, onKeyDown: emptyFn })));
    };
    MonthPanel.prototype.renderBody = function () {
        var prefixCls = this.prefixCls;
        var _a = this.props, cellRender = _a.cellRender, contentRender = _a.contentRender, disabledDate = _a.disabledDate, locale = _a.locale;
        var value = this.state.value;
        return (h("div", { className: prefixCls + "-body" },
            h(MonthTable, { cellRender: cellRender, contentRender: contentRender, disabledDate: disabledDate, locale: locale, prefixCls: prefixCls, value: value, onSelect: this.setAndSelectValue })));
    };
    MonthPanel.prototype.renderFooter = function () {
        var prefixCls = this.prefixCls;
        var renderFooter = this.props.renderFooter;
        var footer = renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter('month');
        return footer ? (h("div", { className: prefixCls + "-footer" }, footer)) : null;
    };
    MonthPanel.prototype.render = function () {
        var style = this.props.style;
        var prefixCls = this.prefixCls;
        return (h("div", { className: prefixCls, style: style },
            h("div", null,
                this.renderHeader(),
                this.renderBody(),
                this.renderFooter())));
    };
    return MonthPanel;
}(React.Component));
MonthPanel.propTypes = {
    cellRender: PropTypes.func,
    contentRender: PropTypes.func,
    defaultValue: PropTypes.instanceOf(dayjs),
    disabledDate: PropTypes.func,
    locale: PropTypes.shape({
        nextYear: PropTypes.string,
        previousYear: PropTypes.string,
        yearSelect: PropTypes.string,
    }),
    renderFooter: PropTypes.func,
    rootPrefixCls: PropTypes.string,
    style: PropTypes.shape({}),
    value: PropTypes.instanceOf(dayjs),
    onSelect: PropTypes.func,
    onYearPanelShow: PropTypes.func,
};
MonthPanel.defaultProps = {
    cellRender: undefined,
    contentRender: undefined,
    defaultValue: undefined,
    disabledDate: undefined,
    locale: {},
    onSelect: emptyFn,
    onYearPanelShow: emptyFn,
    renderFooter: undefined,
    rootPrefixCls: '',
    style: {},
};
export default MonthPanel;
